import { getXiaomanFields, getXiaomanSyncFields, upXiaomanFieldAssoc } from '@/services/configXiaoman'

export default {
  namespaced: true,
  state: {
    columns: [{
      title: '小满字段',
      key: 'xiaoman'
    }, {
      title: '星轨字段',
      key: 'westartrack'
    }],
    listDatas: [],
    allSelectOptions: {},

    fieldsLoading: undefined,
    count: 0,
    isBtnDisable: false
  },
  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_ALL_OPTIONS (state, data) {
      state.allSelectOptions = data
    },
    SET_LOADING (state, data) {
      state.fieldsLoading = data
    },
    SET_COUNT (state, data) {
      state.count = data
    },
    SET_SAVE_BTN_DISABLED (state, data) {
      state.isBtnDisable = data
    }
  },

  actions: {
    async fetchAllOptions ({ commit }, params) {
      let chain = await getXiaomanFields()
      chain
        .params(params)
        .config({ tip: false, warn: false })
        .onSuccess(res => {
          commit('SET_ALL_OPTIONS', res)
        })
        .fetch()
      return chain
    },
    async fetchXiaomanSyncFields ({ commit, rootState }, params) {
      commit('SET_LOADING', true)
      let chain = await getXiaomanSyncFields()
      chain
        .params(params)
        .config({ tip: false })
        .onNetSuccess(raw => {
          commit('SET_LOADING', false)
        })
        .onSuccess(res => {
          commit('SET_LOADING', false)
          commit('setListDatas', res.list)
        })
        .fetch()
      return chain
    },
    async setXiaomanFieldAssoc ({ commit }, params) {
      let chain = await upXiaomanFieldAssoc()
      chain
        .params(params)
        .fetch()
      return chain
    }
  }
}
